// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sideBar.module.css */

.sideBar_sidebar__VH\\+Wi {
  width: 290px ;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #024267d4;
  color: white;
  z-index: 1;

}

.sideBar_sidebarContent__28CPr {
  flex: 1 1;

}

.sideBar_footer__\\+kVg- {
  padding-bottom: 2px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #12274ee3;
  color: white;
  text-align: center;
}

.sideBar_logo__rWhOv {
  width: 120px;
}

.sideBar_containerNav__tgJj9 {
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.sideBar_logo_user__acdiW {
  display: flex;
  align-items: center;
}

.sideBar_user__LMzx1 {
  display: flex;
  align-items: center;
  margin-right: 10px;
  text-decoration: none;
  padding-right: 5px;
  padding-left: 5px;
}

.sideBar_boton__7MFBn .sideBar_dropdown-menu__jrrGk {
  background-color: #343a40;
  color: white;
}

.sideBar_boton__7MFBn .sideBar_dropdown-item__X9GOM {
  color: white;
}

.sideBar_dropdown-menu__jrrGk:hover{
  background-color: #343a40 !important;
}

.sideBar_dropdown-item__X9GOM {
  color: white;

}

a:hover {
  color: #f7b681 !important;
  
}
.sideBar_navLink__F7KW9.sideBar_active__I8CCI {
  color: #f7b681 !important;

  font-weight: 600;
}
.sideBar_dropdownMenu__VOMXG{
background-color: #04558569 !important;
 list-style: none;
}

.sideBar_content__grq6H {
  margin-left: 250px;
  padding: 20px;
  overflow-y: auto;
}


@media only screen and (min-width: 768px) and (max-width: 1023px) {

  .sideBar_bodySide__RdBr9 ul li a{
  
    font-size: 19px;
   
  }
}
@media only screen and (max-width: 650px) {
  .sideBar_logo__rWhOv{
    width: 8rem;
  }
  .sideBar_close__CTKzk{
    display: block;
  }
  .sideBar_iconNav__iru-h{
    display: block;
  }
  .sideBar_contenedorSide__NsE8x{
    width: 40vh !important;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/sideBar.module.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,UAAU;;AAEZ;;AAEA;EACE,SAAO;;AAET;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,yBAAyB;;AAE3B;AACA;EACE,yBAAyB;;EAEzB,gBAAgB;AAClB;AACA;AACA,sCAAsC;CACrC,gBAAgB;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;;AAGA;;EAEE;;IAEE,eAAe;;EAEjB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;;AAEF","sourcesContent":["/* sideBar.module.css */\n\n.sidebar {\n  width: 290px ;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background-color: #024267d4;\n  color: white;\n  z-index: 1;\n\n}\n\n.sidebarContent {\n  flex: 1;\n\n}\n\n.footer {\n  padding-bottom: 2px;\n  padding-left: 10px;\n  padding-right: 10px;\n  background-color: #12274ee3;\n  color: white;\n  text-align: center;\n}\n\n.logo {\n  width: 120px;\n}\n\n.containerNav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n}\n\n.logo_user {\n  display: flex;\n  align-items: center;\n}\n\n.user {\n  display: flex;\n  align-items: center;\n  margin-right: 10px;\n  text-decoration: none;\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.boton .dropdown-menu {\n  background-color: #343a40;\n  color: white;\n}\n\n.boton .dropdown-item {\n  color: white;\n}\n\n.dropdown-menu:hover{\n  background-color: #343a40 !important;\n}\n\n.dropdown-item {\n  color: white;\n\n}\n\na:hover {\n  color: #f7b681 !important;\n  \n}\n.navLink.active {\n  color: #f7b681 !important;\n\n  font-weight: 600;\n}\n.dropdownMenu{\nbackground-color: #04558569 !important;\n list-style: none;\n}\n\n.content {\n  margin-left: 250px;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n\n@media only screen and (min-width: 768px) and (max-width: 1023px) {\n\n  .bodySide ul li a{\n  \n    font-size: 19px;\n   \n  }\n}\n@media only screen and (max-width: 650px) {\n  .logo{\n    width: 8rem;\n  }\n  .close{\n    display: block;\n  }\n  .iconNav{\n    display: block;\n  }\n  .contenedorSide{\n    width: 40vh !important;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `sideBar_sidebar__VH+Wi`,
	"sidebarContent": `sideBar_sidebarContent__28CPr`,
	"footer": `sideBar_footer__+kVg-`,
	"logo": `sideBar_logo__rWhOv`,
	"containerNav": `sideBar_containerNav__tgJj9`,
	"logo_user": `sideBar_logo_user__acdiW`,
	"user": `sideBar_user__LMzx1`,
	"boton": `sideBar_boton__7MFBn`,
	"dropdown-menu": `sideBar_dropdown-menu__jrrGk`,
	"dropdown-item": `sideBar_dropdown-item__X9GOM`,
	"navLink": `sideBar_navLink__F7KW9`,
	"active": `sideBar_active__I8CCI`,
	"dropdownMenu": `sideBar_dropdownMenu__VOMXG`,
	"content": `sideBar_content__grq6H`,
	"bodySide": `sideBar_bodySide__RdBr9`,
	"close": `sideBar_close__CTKzk`,
	"iconNav": `sideBar_iconNav__iru-h`,
	"contenedorSide": `sideBar_contenedorSide__NsE8x`
};
export default ___CSS_LOADER_EXPORT___;
